import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import {useDispatch} from 'react-redux';
import {navigateNext, setLevel} from '../../action/actions';
import Button from './Button';
import Api from '../../util/api';
import {publicBuildUrl} from '../../config/config';

const StartLevel = ({level, navigateTo, text}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setLevel(level));
    });

    return (
        <Page title={'Start or resume'}>
            <div className={'bodyContainer'}>
                <div className={'bodyContainerColumn'}>
                    <img src={`${publicBuildUrl}images/StartLevel${level}.png`} alt={'Cast'} style={{width: '560px'}}/>
                </div>
                <div className={'bodyContainerColumn'} style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                }}>
                    <div style={styles.text}>
                        {text}
                    </div>
                    <div style={{width: '310px'}}>
                        <Button onClick={() => {
                            Api.navigateDeviceToPage(navigateTo).then(
                                dispatch(navigateNext())
                            )
                        }} color={'green'} text={'Start level'}/>
                    </div>
                </div>
            </div>
        </Page>
    )
};

StartLevel.propTypes = {
    level: PropTypes.number.isRequired,
    navigateTo: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
}

const styles = {
    text: {
        marginBottom: '35px',
        fontFamily: 'Ubuntu',
        fontWeight: 500,
        fontSize: '20px',
    }
}

export default StartLevel;
